export const DeclarationTreeItemRendererName = 'declarationTreeItemRendererComponent';
